import React from "react"
import {PlusSquareOutlined} from "@ant-design/icons";

import {IconButton} from "controls/react/form/iconButton";
import {sortAlphabetically} from 'tools/utils';
import {GlobalTimePeriodWidgetType} from "controls/designer/features/widgets/globalTimeSelector";
import {ExportWidgetType} from "controls/designer/features/widgets/export/types";

import {i18n} from 'core/localization';


let menuStructure = null;
export function getWidgetsMenuStructure(){
	if(menuStructure == null) {
		menuStructure = [
			{
				title: i18n('Application'),
				icon: 'artificial-intelligence',
				widgets: [{
					type: 'application-preview',
					title: i18n('Preview'),
					icon: 'artificial-intelligence'
				}]
			},{
				title: i18n('Datasource'),
				icon: 'picture',
				widgets: [{
					type: GlobalTimePeriodWidgetType,
					title: i18n('Datasource Time Selector'),
					icon: 'picture'
				},{
					type: 'data-sources-chart',
					title: i18n('Datasource chart'),
					icon: 'table'
				},{
					type: 'data-sources-grid',
					title: i18n('Datasource grid'),
					icon: 'table'
				},{
					type: 'data-sources-tile',
					title: i18n('Datasource tile'),
					icon: 'picture'
				},{
					type: 'data-sources-single-graph',
					title: i18n('Datasource single graph'),
					icon: 'stats'
				},{
					type: ExportWidgetType,
					title: i18n('Export'),
					icon: 'export'
				}]
			}, {
				title: i18n('Presentation'),
				icon: 'picture',
				widgets: [{
					type: 'dashboard',
					title: i18n('Dashboard'),
					icon: 'picture'
				},{
					type: 'report',
					title: i18n('Report'),
					icon: 'picture'
				}]
			}, {
				title: i18n('Service'),
				icon: 'git-merge',
				widgets: [{
					type: 'service-preview',
					title: i18n('Preview'),
					icon: 'camera'
				}, {
					type: 'service-summary',
					title: i18n('Grouped summary'),
					icon: 'justify'
				}, {
					type: 'service-summary-grid',
					title: i18n('Summary grid'),
					icon: 'justify'
				}, {
					type: 'service-events',
					title: i18n('Event summary'),
					icon: 'table'
				}, {
					type: 'service-history',
					title: i18n('History'),
					icon: 'book-open'
				}, {
					type: 'service-selective',
					title: i18n('Selective Services'),
					icon: 'list'
				}, {
					type: 'service-grid',
					title: i18n('Grid'),
					icon: 'table'
				}, {
					type: 'service-single-graph',
					title: i18n('Single Graph'),
					icon: 'stats'
				}, {
					type: 'service-multi-graph',
					title: i18n('Multigraph'),
					icon: 'stats'
				}, {
					type: 'service-gauge',
					title: i18n('Gauge'),
					icon: 'dashboard'
				},{
					type: 'service-document',
					title: i18n('Document'),
					icon: 'file'
				}]
			}, {
				title: i18n('Metric'),
				icon: 'charts',
				widgets: [{
					type: 'metric-single-graph',
					title: i18n('Single Graph'),
					icon: 'stats'
				}, {
					type: 'metric-multi-graph-asset',
					title: i18n('Multigraph (Asset)'),
					icon: 'stats'
				}, {
					type: 'metric-multi-graph-asset-group',
					title: i18n('Multigraph (Asset Group)'),
					icon: 'stats'
				}, {
					type: 'metric-gauge',
					title: i18n('Gauge'),
					icon: 'dashboard'
				}, {
					type: 'metric-stacked-chart',
					title: i18n('Stacked Chart'),
					icon: 'stats'
				}, {
					type: 'metric-custom',
					title: i18n('Custom') + ' - (' + i18n('Experimental') + ')',
					icon: 'stats'
				}, {
					type: 'metric-barchart',
					title: i18n('Linear gauge') ,
					icon: 'dashboard'
				}, {
					type: 'metric-table',
					title: i18n('Table') ,
					icon: 'dashboard'
				}, {
					type: 'metric-sparkline-table',
					title: i18n('Sparkline Table'),
					icon: 'stats'
				}, {
					type: 'indicator-dots',
					title: i18n('Indicator'),
					icon: 'table'
				}, {
					type: 'metric-tile',
					title: i18n('Tile'),
					icon: 'table'
				},{
					type: 'metric-dial',
					title: i18n('Dial'),
					icon: 'stats'
				},{
					type: 'metric-common-gauge',
					title: i18n('Metric gauge'),
					icon: 'stats'
				},{
					type: 'metric-compass',
					title: i18n('Radial Gauge'),
					icon: 'stats'
				}]
			}, {
				title: i18n('Health'),
				icon: 'heart-empty',
				widgets: [{
					type: 'health-single-graph',
					title: i18n('Single Graph'),
					icon: 'stats'
				}, {
					type: 'health-multi-graph',
					title: i18n('Multigraph'),
					icon: 'stats'
				}, {
					type: 'health-gauge',
					title: i18n('Gauge'),
					icon: 'dashboard'
				}]
			}, {
				title: i18n('Asset'),
				icon: 'heartbeat',
				widgets: [{
					type: 'asset-grid',
					title: i18n('Grid'),
					icon: 'table'
				}, {
					type: 'asset-console',
					title: i18n('Console'),
					icon: 'heart'
				}, {
					type: 'asset-assetgroup',
					title: i18n('Asset Group'),
					icon: 'table'
				}]
			}, {
				title: i18n('SLA'),
				icon: 'record',
				widgets: [{
					type: 'sla',
					title: i18n('SLA'),
					icon: 'justify'
				}, {
					type: 'sla-history',
					title: i18n('History'),
					icon: 'stats'
				}, {
					type: 'sla-time',
					title: i18n('Time'),
					icon: 'justify'
				}, {
					type: 'sla-grid',
					title: i18n('Grid'),
					icon: 'table'
				}]
			}, {
				title: i18n('KPI'),
				icon: 'equalizer',
				widgets: [{
					type: 'kpi-single-graph',
					title: i18n('Single Graph'),
					icon: 'stats'
				}, {
					type: 'kpi-multi-graph',
					title: i18n('Multi Graph'),
					icon: 'stats'
				}, {
					type: 'kpi-gauge',
					title: i18n('Gauge'),
					icon: 'dashboard'
				}, {
					type: 'kpi-history',
					title: i18n('History'),
					icon: 'stats'
				}]
			}, {
				title: i18n('Grid'),
				icon: 'table',
				widgets: [{
					type: 'summary-grid',
					title: i18n('Home'),
					icon: 'table'
				}, {
					type: 'reasons-grid',
					title: i18n('Health Reasons'),
					icon: 'table'
				}, {
					type: 'incidents-grid',
					title: i18n('Incidents'),
					icon: 'table'
				}, {
					type: 'event-summary-grid',
					title: i18n('Event summary'),
					icon: 'table'
				}]
			}, {
				title: i18n('Custom'),
				icon: 'text-size',
				widgets: [{
					type: 'text',
					title: i18n('Text'),
					icon: 'text-size',
				}, {
					type: 'time',
					title: i18n('Time'),
					icon: 'text-size'
				}, {
					type: 'web-page',
					title: i18n('Web Page'),
					icon: 'text-size'
				}, {
					type: 'gps',
					title: i18n('GPS'),
					icon: 'map-marker'
				},{
					type: 'ai-query',
					title: i18n(('AI Query')),
					icon: 'map-marker'
				}]
			},{
				title: i18n('Cloud'),
				icon: 'text-size',
				widgets: [{
					type: 'cloud-services-cost-bar-chart',
					title: i18n('Bar Chart'),
					icon: 'table'
				}, {
					type: 'cloud-services-cost-grid',
					title: i18n('Grid'),
					icon: 'table'
				}, {
					type: 'cloud-services-instances-grid',
					title: i18n('Instances Grid'),
					icon: 'table'
				}, {
					type: 'cloud-services-buggle-chart',
					title: i18n('Bubble Chart'),
					icon: 'credit'
				}]
			}, {
				title: i18n('Cost'),
				icon: 'euro',
				widgets: [{
					type: 'budget-cost-bar-chart',
					title: i18n('Bar Chart'),
					icon: 'table'
				}, {
					type: 'cost-grid',
					title: i18n('Cost Grid'),
					icon: 'table'
				}, {
					type: 'cost-profile',
					title: i18n('Cost model'),
					icon: 'table'
				}, {
					type: 'cost-pie-chart',
					title: i18n('Cost Pie'),
					icon: 'table'
				}]
			}, {
				title: i18n('State'),
				icon: 'list',
				widgets: [{
					type: 'application-state',
					title: i18n('Application'),
					icon: 'artificial-intelligence'
				}, {
					type: 'service-state',
					title: i18n('Service'),
					icon: 'git-merge'
				}, {
					type: 'asset-state',
					title: i18n('Asset'),
					icon: 'hospital'
				}, {
					type: 'sla-state',
					title: i18n('SLA'),
					icon: 'record'
				}, {
					type: 'event-state',
					title: i18n('Event'),
					icon: 'article'
				}]
			}
		];
	}

	menuStructure.sort(sortAlphabetically);

	for (let menuItem of menuStructure) {
		menuItem.widgets.sort(sortAlphabetically);
	}

	return menuStructure;
}

export function generateMenuItems(includeRoot, includeIcon, clickCallback) {
	const rootItem = {
		icon: <PlusSquareOutlined/>,
		key: 'root'
	}

	const menuItems = getWidgetsMenuStructure().map(section => {
		return {
			label: section.title,
			key: section.title,
			onTitleClick: event => {event.domEvent.stopPropagation()},
			children: section.widgets.map(widgetMenuEntry => {
				return {
					key: widgetMenuEntry.type,
					onClick: clickCallback,
					label: widgetMenuEntry.title,
					icon: (includeIcon && widgetMenuEntry.icon) ? <IconButton embedded={true} iconName={widgetMenuEntry.icon}/> : undefined
				}
			}
			)
		}
	})

	if(includeRoot){
		rootItem.children = menuItems;
		return [rootItem]
	}
	else {
		return menuItems;
	}
 }
